import { useNavigate } from "react-router-dom";
import { InvoiceGenerator} from "./invoiceGenerator";
import { useDispatch, useSelector } from "react-redux";


export const useInvoiceActions = () => {
  const navigate = useNavigate();
    const user = useSelector((state) => state.user.userDetails);
    const basicInfo = user ? user : {};

  

  const showEstimateInvoice = (eventCart) => {
  
    // const eventCart = Object.values(carts).find(
    //   (cart) => cart.event['id'] === eventId
    // );

    if (!eventCart) {
      alert("Event not found");
      return;
    }

    const invoice = InvoiceGenerator.generateEstimateInvoice(eventCart);

    navigate("/invoice", {
      state: { invoice,company:InvoiceGenerator.companyData(),user:{...basicInfo}}
    });
  };

  const showPaymentInvoice = (orders, eventId) => {
   
    if (!orders) return;

    const invoice =
      InvoiceGenerator.generatePaymentInvoice(orders);

    navigate("/invoice", {
      state: { invoice,company:InvoiceGenerator.companyData(),user:{...basicInfo}}
    });
  };

  const showPaymentReceipt = (orders, eventId) => {
  
    if (!orders) return;

    const invoice =
      InvoiceGenerator.generateReceiptInvoice(orders);

    navigate("/invoice", {
      state: { invoice,company:InvoiceGenerator.companyData(),user:{...basicInfo}}
    });
  };

  return {
    showEstimateInvoice,
    showPaymentInvoice,
    showPaymentReceipt
  };
};